/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbFormateurAzureGridDto
 */
export interface FcbFormateurAzureGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurAzureGridDto
     */
    idFormateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurAzureGridDto
     */
    idCentre?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurAzureGridDto
     */
    centre?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbFormateurAzureGridDto
     */
    azureActive?: boolean;
}

/**
 * Check if a given object implements the FcbFormateurAzureGridDto interface.
 */
export function instanceOfFcbFormateurAzureGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurAzureGridDtoFromJSON(json: any): FcbFormateurAzureGridDto {
    return FcbFormateurAzureGridDtoFromJSONTyped(json, false);
}

export function FcbFormateurAzureGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurAzureGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'idCentre': !exists(json, 'idCentre') ? undefined : json['idCentre'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
        'azureActive': !exists(json, 'azureActive') ? undefined : json['azureActive'],
    };
}

export function FcbFormateurAzureGridDtoToJSON(value?: FcbFormateurAzureGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFormateur': value.idFormateur,
        'idCentre': value.idCentre,
        'centre': value.centre,
        'azureActive': value.azureActive,
    };
}

